import React from 'react';

import * as _Image from '../common/Image.jsx';

function Image(props) {
    const artist = props.itemData || {};
    return <_Image.Component {...props} alt={artist.Name} image={artist.Image} imageUrl={artist.ImageUrl} url={artist.Url} />
}

const TypeConfig = _Image.TypeConfig;
export {
    Image as Component,
    TypeConfig
};